import React from "react";
import Page from "../components/Page";
import BackButton from "../components/BackButton";
import { Badge, Table } from "react-bootstrap";
import ScrollToTop from "../components/ScrollToTop";
import useIsMobile from "../hooks/useIsMobile";
import { patreonUrl } from "../constants";

const Rules = () => {
  const isMobile = useIsMobile();

  return (
    <Page>
      <div className="page-bar">
        <div className="inner">
          <ScrollToTop />
          <div style={{ display: "flex", alignItems: "center" }}>
            <BackButton />
            <h4 className="bar-title">
              Правила гри
              <br />
              2026/2027
            </h4>
          </div>
        </div>
      </div>
      <div className="page-offset">
        <h5 style={{ marginBottom: 12 }}>
          <i className="bi bi-patch-question"></i>&nbsp;Як почати грати?
        </h5>
        <p>
          ✅ Зберіть команду з 15 футболістів – 11 основних і 4 заміни. Склад
          має включати 2 голкіперів, 5 захисників, 5 півзахисників і 3
          нападники.
        </p>
        <p>✅ Загальна вартість вашої команди має не перевищувати 100 монет.</p>
        <p>✅ Ви не можете взяти більше 2 футболістів одного клубу.</p>
        <p id="scheme-rules" style={{ scrollMarginTop: 115 }}>
          ✅ Оберіть схему гри. Вона має включати 1 голкіпера, мінімум 3
          захисники, мінімум 2 півзахисники та мінімум 1 нападника. Схему можна
          змінювати кожного туру.
        </p>
        <p>
          ✅ Кожного туру обирайте капітана (К) та віце-капітана (ВК). Очки
          капітана подвоюються. Якщо основний капітан не зіграв, то подвояться
          очки віце-капітана.{" "}
        </p>
        <p>
          ✅ Кожного туру за допомогою кнопки{" "}
          <i className="bi bi-gear-fill"></i> "Пріоритети" визначайте порядок,
          за яким можуть зіграти запасні гравці.
        </p>
        <p>
          ✅ Будьте уважні - усі ваші зміни у складі мають бути підтверджені
          натисканням кнопки «Зберегти». Дедлайн будь-яких змін у складі – за
          1,5 години до початку першого матчу кожного туру.
        </p>
        <p>
          ✅ Якщо ви зберегли зміни в складі, але передумали до дедлайну, можете
          один раз між турами скасувати свої дії і повернутись до складу
          минулого туру, натиснувши кнопку <i className="bi bi-trash"></i>. Ця
          опція доступна лише під час турів з обмеженою кількістю трансферів.
        </p>
        <h5 style={{ marginBottom: 12 }}>
          <i className="bi bi-patch-question"></i>&nbsp;Як грати далі?
        </h5>
        <p>
          ✅ Очки для вашої команди набирають основні гравці. Запасні виходять
          на заміну автоматично, якщо основні не зіграли. Польовий запасний
          гравець може замінити будь-якого польового гравця, якщо ця заміна не
          порушує <a href="#scheme-rules">правил схеми гри</a>.
        </p>
        <p>✅ Голкіпер може бути замінений тільки іншим голкіпером.</p>
        <p>
          ✅ Після кожного туру ви можете зробити заміни і 2 трансфери – продати
          і купити 2 гравців. Перші три тури і стартовий тур після зимової паузи
          – кількість трансферів необмежена. Невикористані трансфери
          зберігаються та можуть бути використані у наступних турах.
        </p>{" "}
        <p>
          ✅ Перенесені/недограні матчі будуть прикріплятись до туру перед цим
          матчем. Наприклад, якщо перенесений матч буде зіграно/дограно між 20-м
          і 21-м турами, то він буде прикріплений до 20-го туру.
        </p>
        <p>
          ✅ Ви можете грати в FANTASY UPL безкоштовно протягом 3 тижнів з
          моменту реєстрації. Після чого потрібно{" "}
          <a href={patreonUrl} target="_blank" rel="noreferrer">
            стати патроном KDK
          </a>{" "}
          з місячним платежем $2 або більше.
        </p>
        <h5 style={{ marginBottom: 12 }}>
          <i className="bi bi-patch-question"></i>&nbsp;Як нараховуються бали?
        </h5>
        <p>
          ✅ Гравці набирають очки в залежності від власних дій і результатів
          їхніх команд. Для розраxунку очок ми використовуємо інформацію з
          офіційного{" "}
          <a rel="noreferrer" target="_blank" href="https://upl.ua">
            веб-сайту УПЛ
          </a>{" "}
          та{" "}
          <a rel="noreferrer" target="_blank" href="https://ua.tribuna.com">
            веб-сайту Tribuna.com
          </a>
        </p>
        <p>
          ✅ Якщо матч завершився технічною поразкою, очки не нараховуються за
          дії, які не відбулися на футбольному полі. Матч з точки зору
          фентезі-футболу вважається незіграним.
        </p>
        {isMobile ? (
          <Table striped size="sm" style={{ fontSize: "1.3rem" }}>
            <thead>
              <tr>
                <th>Правило</th>
                <th>Бали</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Зіграв менше 59 хвилин</td>
                <td>1</td>
              </tr>
              <tr>
                <td>Зіграв 59+ хвилин (без врахування доданого часу)</td>
                <td>2</td>
              </tr>
              <tr>
                <td>За гол голкіпера</td>
                <td>7</td>
              </tr>
              <tr>
                <td>За гол захисника</td>
                <td>6</td>
              </tr>
              <tr>
                <td>За гол півзахисника</td>
                <td>5</td>
              </tr>
              <tr>
                <td>За гол нападника</td>
                <td>4</td>
              </tr>
              <tr>
                <td>За гол голкіпера з пенальті</td>
                <td>5</td>
              </tr>
              <tr>
                <td>За гол захисника з пенальті</td>
                <td>4</td>
              </tr>
              <tr>
                <td>За гол півзахисника з пенальті</td>
                <td>3</td>
              </tr>
              <tr>
                <td>За гол нападника з пенальті</td>
                <td>2</td>
              </tr>
              <tr>
                <td>За гольовий асист голкіпера</td>
                <td>5</td>
              </tr>
              <tr>
                <td>За гольовий асист захисника</td>
                <td>4</td>
              </tr>
              <tr>
                <td>За гольовий асист півзахисника</td>
                <td>3</td>
              </tr>
              <tr>
                <td>За гольовий асист нападника</td>
                <td>2</td>
              </tr>
              <tr>
                <td>
                  За сухий матч команди голкіпера<sup>1</sup>
                </td>
                <td>5</td>
              </tr>
              <tr>
                <td>
                  За сухий матч команди захисника<sup>1</sup>
                </td>
                <td>4</td>
              </tr>
              <tr>
                <td>
                  За сухий матч команди півзахисника<sup>1</sup>
                </td>
                <td>2</td>
              </tr>
              <tr>
                <td>
                  За сухий матч команди нападника<sup>1</sup>
                </td>
                <td>1</td>
              </tr>
              <tr>
                <td>Заробив пенальті в чужі ворота</td>
                <td>1</td>
              </tr>
              <tr>
                <td>Заробив пенальті в свої ворота</td>
                <td>-1</td>
              </tr>
              <tr>
                <td>Не дозволив забити з пенальті</td>
                <td>4</td>
              </tr>
              <tr>
                <td>За нереалізований пенальті</td>
                <td>-2</td>
              </tr>
              <tr>
                <td>
                  За вольову перемогу (команда першою пропустила, але перемогла)
                  <sup>1</sup>
                </td>
                <td>1</td>
              </tr>
              <tr>
                <td>
                  За кожні забиті командою 2 голи для нападника або півзахисника
                  <sup>1</sup>
                </td>
                <td>1</td>
              </tr>
              <tr>
                <td>
                  За кожні пропущені командою 2 голи для голкіпера або захисника
                  <sup>1</sup>
                </td>
                <td>-1</td>
              </tr>
              <tr>
                <td>
                  За жовту картку<sup>2</sup>
                </td>
                <td>-1</td>
              </tr>
              <tr>
                <td>
                  За червону картку<sup>2</sup>
                </td>
                <td>-3</td>
              </tr>
              <tr>
                <td>За автогол</td>
                <td>-2</td>
              </tr>
            </tbody>
          </Table>
        ) : (
          <Table
            className="rules-table"
            striped
            size="sm"
            style={{ fontSize: "1.3rem" }}
          >
            <thead>
              <tr>
                <th style={{ textAlign: "left" }}>Правило</th>
                <th>
                  <Badge style={{ color: "#161616" }}>ГК</Badge>
                </th>
                <th>
                  <Badge style={{ color: "#161616" }}>ЗАХ</Badge>
                </th>
                <th>
                  <Badge style={{ color: "#161616" }}>ПІВ</Badge>
                </th>
                <th>
                  <Badge style={{ color: "#161616" }}>НАП</Badge>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Зіграв 59+ хвилин (без врахування доданого часу)</td>
                <td>2</td>
                <td>2</td>
                <td>2</td>
                <td>2</td>
              </tr>
              <tr>
                <td>Зіграв менше 59 хвилин</td>
                <td>1</td>
                <td>1</td>
                <td>1</td>
                <td>1</td>
              </tr>
              <tr>
                <td>Гол</td>
                <td>7</td>
                <td>6</td>
                <td>5</td>
                <td>4</td>
              </tr>
              <tr>
                <td>Гол з пенальті</td>
                <td>5</td>
                <td>4</td>
                <td>3</td>
                <td>2</td>
              </tr>
              <tr>
                <td>Заробив пенальті в чужі ворота</td>
                <td>1</td>
                <td>1</td>
                <td>1</td>
                <td>1</td>
              </tr>
              <tr>
                <td>Заробив пенальті в свої ворота</td>
                <td>-1</td>
                <td>-1</td>
                <td>-1</td>
                <td>-1</td>
              </tr>
              <tr>
                <td>Не забив з пенальті</td>
                <td>-2</td>
                <td>-2</td>
                <td>-2</td>
                <td>-2</td>
              </tr>
              <tr>
                <td>Не дозволив забити з пенальті</td>
                <td>4</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>Автогол</td>
                <td>-2</td>
                <td>-2</td>
                <td>-2</td>
                <td>-2</td>
              </tr>
              <tr>
                <td>Асист</td>
                <td>5</td>
                <td>4</td>
                <td>3</td>
                <td>2</td>
              </tr>
              <tr>
                <td>
                  Сухий матч команди<sup>1</sup>
                </td>
                <td>5</td>
                <td>4</td>
                <td>2</td>
                <td>1</td>
              </tr>
              <tr>
                <td>
                  Кожні 2 пропущені командою м'ячі<sup>1</sup>
                </td>
                <td>-1</td>
                <td>-1</td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>
                  Кожні 2 забиті командою м'ячі<sup>1</sup>
                </td>
                <td></td>
                <td></td>
                <td>1</td>
                <td>1</td>
              </tr>
              <tr>
                <td>
                  Вольова перемога<sup>1</sup>
                </td>
                <td>1</td>
                <td>1</td>
                <td>1</td>
                <td>1</td>
              </tr>

              <tr>
                <td>
                  Жовта картка<sup>2</sup>
                </td>
                <td>-1</td>
                <td>-1</td>
                <td>-1</td>
                <td>-1</td>
              </tr>
              <tr>
                <td>
                  Червона картка<sup>2</sup>
                </td>
                <td>-3</td>
                <td>-3</td>
                <td>-3</td>
                <td>-3</td>
              </tr>
            </tbody>
          </Table>
        )}
        <p>
          <sup>1</sup> - футболіст має знаходитись у грі 59+ хвилин.
        </p>
        <p>
          <sup>2</sup> - якщо футболіст отримує дві жовті та автоматичну
          червону, то рахуватиметься тільки червона картка.
        </p>
        <h5 style={{ marginBottom: 12 }}>
          <i className="bi bi-gift-fill"></i>&nbsp;Рейтинги та подарунки{" "}
        </h5>
        <p>
          ✅ Очки вашої команди нараховуються в 4 рейтингах – загальний,
          місячний, туру і ліга вболівальників вашого клубу. Змінити улюблений
          клуб можна лише один раз протягом місяця з моменту реєстрації у
          турнірі.{" "}
        </p>
        <p>
          ✅ Переможці турів отримають безкоштовний доступ до нашої Фентезі на
          весь сезон. Переможці місяців – приз УПЛ,{" "}
          <b>офіційний м'яч Прем'єр-ліги </b> від{" "}
          <a href="https://ua.puma.com/uk" target="_blank" rel="noreferrer">
            Puma
          </a>
          . Топ-10 загального рейтингу за підсумками сезону виграють{" "}
          <strong>річну преміальну підписку </strong> на{" "}
          <a href="https://tv.kyivstar.ua/" target="_blank" rel="noreferrer">
            Київстар ТБ
          </a>{" "}
        </p>
        <p>
          ✅ Переможці клубних рейтингів отримають подарунки –{" "}
          <strong>футболки своїх улюблених команд</strong>. Цього сезону
          погодились підтримати своїх вболівальників Шахтар, ЛНЗ, Полісся,
          Харків, Колос, Кривбас, Епіцентр, Верес, Оболонь, Кудрівка,
          Чорноморець, Буковина і Лівий Берег.
        </p>
        <p>
          ✅ У випадку рівності очок переможці рейтингів визначаються за меншою
          кількістю: а) автозамін, б) очок капітана. Якщо всі додаткові
          показники рівні - за допомогою рандомайзера.
        </p>
        <h5 style={{ marginBottom: 12 }}>
          <i className="bi bi-patch-question"></i>&nbsp;Що ще треба знати?{" "}
        </h5>
        <p>
          ✅ Ви можете створити власну приватну лігу і змагатися з тими, кому
          передасте посилання на неї.
        </p>
        <p>
          ✅ Організатори гри залишають за собою право деактивувати учасників,
          які були неактивними у грі протягом двох і більше місяців.{" "}
        </p>
        <p>
          ✅ Підпишіться на{" "}
          <a
            href={process.env.REACT_APP_TELEGRAM_CHANNEL_LINK}
            target="_blank"
            rel="noreferrer"
          >
            офіційний канал {process.env.REACT_APP_FANTASY_TITLE}
          </a>{" "}
          – там ми будемо нагадувати зробити зміни в складі перед стартом
          кожного туру, повідомляти про важливі новини і відповідати на ваші
          питання/зауваження.
        </p>
      </div>
    </Page>
  );
};

export default Rules;
